import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { LinkService } from '../../../_services/langhfre.service';

@Component({
  selector: 'app-latex-grammar-checker',
  templateUrl: './latex-grammar-checker.component.html',
  styleUrls: ['./latex-grammar-checker.component.scss']
})
export class LatexGrammarCheckerComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private LinkService: LinkService,
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle('LaTeX 文件校對｜Trinka AI 一鍵校對 LaTeX 文件 | Trinka AI');
    this.metaTagService.updateTag({ name: 'description', content: "Trinka LaTeX 文件校對功能提供一鍵式文法檢查解決方案，透過自動文法校對，大幅節省您處理 LaTeX 文件的時間。" });
    this.metaTagService.updateTag({ property: 'og:title', content: 'LaTeX 文件校對｜Trinka AI 一鍵校對 LaTeX 文件 | Trinka AI' });
    this.metaTagService.updateTag({ property: 'og:description', content: 'Trinka LaTeX 文件校對功能提供一鍵式文法檢查解決方案，透過自動文法校對，大幅節省您處理 LaTeX 文件的時間。' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/tw/features/latex-grammar-checker' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/Latex-banner.jpg' });
    this.metaTagService.updateTag({ name: 'keywords', content: 'latex grammar checker, grammar checker for latex, grammar checker, grammar and syntax checker, verify grammar, grammar grammar checker, check you grammar, check grammar check, grammar check online' });
    this.metaTagService.updateTag({ name: 'language', content: 'en-us' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: 'LaTeX 文件校對｜Trinka AI 一鍵校對 LaTeX 文件 | Trinka AI' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "Trinka LaTeX 文件校對功能提供一鍵式文法檢查解決方案，透過自動文法校對，大幅節省您處理 LaTeX 文件的時間。" });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/Latex-banner.jpg' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/tw/features/latex-grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/features/latex-grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/features/latex-grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/features/latex-grammar-checker' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/features/latex-grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/features/latex-grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/features/latex-grammar-checker' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/features/latex-grammar-checker' });
    // this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/features/latex-grammar-checker' });
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }

  stopAllVideos() {
    const iframes = Array.from(document.querySelectorAll('iframe.youtubeVideoForTryDemo'));
    iframes.forEach((iframe) => {
        const htmlIframe = iframe as HTMLIFrameElement;
        htmlIframe.src = htmlIframe.src;
    });
  }

}
